import React, { useContext, useEffect, useState } from 'react';
import 'rc-slider/assets/index.css';
import Products from './Products.client';
import Filtters from './Filtters.client';
import Sort from './components/Sort.client';
import filterImage from '../../assets/image/filter.svg';
import { Image } from '@shopify/hydrogen';
import closeFilterIcon from '../../assets/close-filter-icon.svg';
import { useAppSelector } from '../../lib/hooks';
import { isMobile } from '../../lib/Utils';
import { SearchContext } from '../context/Search.client';
import { getParamsUrl, hasUrlSection } from '../../lib/Utils';

export default function Panel() {
  const [isOpenFilters, setIsOpenFilters] = useState(true);
  const [textSearch, setTextSearch] = useState("");
  const fullResponse = useAppSelector((state) => state.search)?.fullResponse;
  const [filterAndOrderText, setFilterAndOrderText] = useState(true);
  const { seoDescription } = useContext(SearchContext);

  const toogleFilters = ()=>{
    setIsOpenFilters(!isOpenFilters);
    toggleFilterbuttonText();
  }

  useEffect(()=>{
    if (window.innerWidth < 768) {
      setIsOpenFilters(false);
    }

    let text = getParamsUrl('q');

    if(hasUrlSection('categoria-producto') || hasUrlSection('etiqueta-producto')){
      let segments = window.location.pathname.split('/');
      text = segments[segments.length - 1];
      text = text.replace(/-/g, ' ');
    }

    setTextSearch(text);
  }, [])

  useEffect(()=>{
    if(isMobile()){
      if(isOpenFilters){
        document.body.classList.add('overflow-hidden');
      }else{
        document.body.classList.remove('overflow-hidden');
      }
    }
  }, [isOpenFilters])

  const toggleFilterbuttonText = ()=>{
    setFilterAndOrderText(!filterAndOrderText);
  }

  return (
    <>
      <div id="search-panel">
        <div className="px-10 pb-5 pt-5 xs:px-3 xs:py-5 flex xs:flex-col md:flex-row xs:items-start items-center justify-between bg-white shadow-sm">
          <div className="flex items-end xs:flex-col xs:items-start xs:m-0">
            <h1 className="page-title">
              Resultados de "{textSearch}" {fullResponse?.totalMatches}
              </h1>
          </div>
          <div class="flex gap-2 xs:flex-row xs:w-full xs:flex xs:justify-between xs:items-center xs:pt-2" id="sort-panel">
            <Sort />
          </div>
        </div>
        <div className="py-5 relative flex flex-wrap collections-wrapper xs:py-0">
        <div
            className={`md:w-3/12 xs:w-full xs:fixed xs:top-0 xs:h-full z-20`}
            style={{ display: isOpenFilters ? 'block' : 'none' }}
          >
            <div
              className={`filter filter-wrapper xs:h-full xs:bg-white overflow-x-auto`}
              style={{ display: isOpenFilters ? 'block' : 'none' }}
            >
              <div className="py-4 px-4">
                <div className="relative">
                  <h2 className="page-title inline mr-2 pl-6 xs:px-0 xs:text-purple-120">
                    Filtrar por
                  </h2>
                  <Image
                    src={closeFilterIcon}
                    height={5}
                    width={10}
                    className="toggle-btn toggle-close w-7 h-full hidden xs:flex"
                    alt="Search"
                    onClick={toogleFilters}
                  />
                </div>
              </div>
              <div id="anchor"></div>
              <div className="border smooth-scroll">
                <Filtters />
              </div>
            </div>
          </div>

          <div className="list-book-result md:w-9/12 xs:w-full px-5 xs:px-4 pt-16 xs:pt-4 pb-5">
            <Products />
          </div>

          <div id='filter-bar'>
            <button
              className="xs:visible md:hidden btn-main btn-wicon btn-icon-left bg-purple-120 text-white font-bold px-5 py-4 rounded-full w-90 xs:p-3 xs:w-8/12 xs:text-sm "
              onClick={toogleFilters}
            >
              <Image
                src={filterImage}
                width={19}
                height={19}
                alt="Filter"
                className="inline mr-2 btn-icon"
              />
              <span className="inline leading-none" onClick={toggleFilterbuttonText}>
                {filterAndOrderText ? (
                  <div>Filtrar y ordenar resultados</div>
                ):(
                  <div>Ver resultados</div>
                )}
              </span>
            </button>
            <button
              className="xs:visible md:hidden btn-main btn-wicon btn-icon-left bg-purple-120 text-white font-bold px-5 py-4 rounded-full w-90 xs:p-3 xs:w-8/12 xs:text-sm "
              onClick={toogleFilters}
            >
              <Image
                src={filterImage}
                width={19}
                height={19}
                alt="Filter"
                className="inline mr-2 btn-icon"
              />
              <span className="inline leading-none">  Ver resultados </span>
            </button>
          </div>
        </div>
        {/* <div className='hidden'>{seoDescription}</div> */}
      </div>
    </>
  );
}